// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fac0e605","170":"2e71cb06","388":"6a68367a","562":"c6c81bed","671":"acd05657","696":"ffe29482","920":"6530601b"}[chunkId] + ".chunk.css";
};